import React from 'react';
import Modal from 'shared/modal';
import Icon from 'icon';
import s from './popup-generator.module.scss';

export default function PopupGenerator({ popupName, popup, ...props }) {
  try {
    const Popup = require(`components/popups/${popupName}`).default;
    return (
      <>
        {popup.isShowing && (
          <Modal>
            <div className={s.popupWrapper}>
              <div className={s.overlay} onClick={() => popup.hide()} />
              <div style={{ zIndex: '99' }}>
                <Popup {...{ popup, ...props }} />
              </div>
            </div>
          </Modal>
        )}
      </>
    );
  } catch (e) {
    console.log(e, 'ERROR');
    return null;
  }
}
